/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ImplantCategory } from 'app/shared/model/enumerations/implant-category.model';
import { ImplantType } from 'app/shared/model/enumerations/implant-type.model';

export interface IImplantGroup {
  id?: string;
  category?: keyof typeof ImplantCategory | null;
  type?: keyof typeof ImplantType | null;
  addedBy?: string | null;
  deviceTypeName?: string | null;
  riskClass?: string | null;
  generalIntendedUse?: string | null;
  timestampentry?: number;
  active?: boolean;
  lastupdated?: number;
  cursor?: number;
  microSec?: number;
}

export const defaultValue: Readonly<IImplantGroup> = {
  active: false,
};
